export const pricesRentMin = [
    {value: '100', text: '€ 100'},
    {value: '200', text: '€ 200'},
    {value: '300', text: '€ 300'},
    {value: '400', text: '€ 400'},
    {value: '500', text: '€ 500'},
    {value: '600', text: '€ 600'},
    {value: '700', text: '€ 700'},
    {value: '800', text: '€ 800'},
    {value: '900', text: '€ 900'},
    {value: '1000', text: '€ 1.000'},
    {value: '1250', text: '€ 1.250'},
    {value: '1500', text: '€ 1.500'},
    {value: '1750', text: '€ 1.750'},
    {value: '2000', text: '€ 2.000'},
    {value: '3000', text: '€ 3.000'},
    {value: '4000', text: '€ 4.000'},
    {value: '5000', text: '€ 5.000'},
    {value: '6000', text: '€ 6.000'}
];

export const pricesRentMax = [
    {value: '100', text: '€ 100'},
    {value: '200', text: '€ 200'},
    {value: '300', text: '€ 300'},
    {value: '400', text: '€ 400'},
    {value: '500', text: '€ 500'},
    {value: '600', text: '€ 600'},
    {value: '700', text: '€ 700'},
    {value: '800', text: '€ 800'},
    {value: '900', text: '€ 900'},
    {value: '1000', text: '€ 1.000'},
    {value: '1250', text: '€ 1.250'},
    {value: '1500', text: '€ 1.500'},
    {value: '1750', text: '€ 1.750'},
    {value: '2000', text: '€ 2.000'},
    {value: '3000', text: '€ 3.000'},
    {value: '4000', text: '€ 4.000'},
    {value: '5000', text: '€ 5.000'},
    {value: '6000', text: '€ 6.000'},
    {value: '7000', text: '€ 7.000'}
];

export const pricesBuyMin = [
    {value: '50000', text: '€ 50.000'},
    {value: '100000', text: '€ 100.000'},
    {value: '125000', text: '€ 125.000'},
    {value: '150000', text: '€ 150.000'},
    {value: '175000', text: '€ 175.000'},
    {value: '200000', text: '€ 200.000'},
    {value: '225000', text: '€ 225.000'},
    {value: '250000', text: '€ 250.000'},
    {value: '275000', text: '€ 275.000'},
    {value: '300000', text: '€ 300.000'},
    {value: '325000', text: '€ 325.000'},
    {value: '350000', text: '€ 350.000'},
    {value: '375000', text: '€ 375.000'},
    {value: '400000', text: '€ 400.000'},
    {value: '450000', text: '€ 450.000'},
    {value: '500000', text: '€ 500.000'},
    {value: '550000', text: '€ 550.000'},
    {value: '600000', text: '€ 600.000'},
    {value: '650000', text: '€ 650.000'},
    {value: '700000', text: '€ 700.000'},
    {value: '750000', text: '€ 750.000'},
    {value: '800000', text: '€ 800.000'},
    {value: '850000', text: '€ 850.000'},
    {value: '900000', text: '€ 900.000'},
    {value: '1000000', text: '€ 1.000.000'},
    {value: '1250000', text: '€ 1.250.000'},
    {value: '1500000', text: '€ 1.500.000'},
    {value: '2000000', text: '€ 2.000.000'},
    {value: '2500000', text: '€ 2.500.000'},
    {value: '3000000', text: '€ 3.000.000'},
    {value: '3500000', text: '€ 3.500.000'},
    {value: '4000000', text: '€ 4.000.000'},
    {value: '4500000', text: '€ 4.500.000'}
];

export const pricesBuyMax = [
    {value: '50000', text: '€ 50.000'},
    {value: '100000', text: '€ 100.000'},
    {value: '125000', text: '€ 125.000'},
    {value: '150000', text: '€ 150.000'},
    {value: '175000', text: '€ 175.000'},
    {value: '200000', text: '€ 200.000'},
    {value: '225000', text: '€ 225.000'},
    {value: '250000', text: '€ 250.000'},
    {value: '275000', text: '€ 275.000'},
    {value: '300000', text: '€ 300.000'},
    {value: '325000', text: '€ 325.000'},
    {value: '350000', text: '€ 350.000'},
    {value: '375000', text: '€ 375.000'},
    {value: '400000', text: '€ 400.000'},
    {value: '450000', text: '€ 450.000'},
    {value: '500000', text: '€ 500.000'},
    {value: '550000', text: '€ 550.000'},
    {value: '600000', text: '€ 600.000'},
    {value: '650000', text: '€ 650.000'},
    {value: '700000', text: '€ 700.000'},
    {value: '750000', text: '€ 750.000'},
    {value: '800000', text: '€ 800.000'},
    {value: '850000', text: '€ 850.000'},
    {value: '900000', text: '€ 900.000'},
    {value: '1000000', text: '€ 1.000.000'},
    {value: '1250000', text: '€ 1.250.000'},
    {value: '1500000', text: '€ 1.500.000'},
    {value: '2000000', text: '€ 2.000.000'},
    {value: '2500000', text: '€ 2.500.000'},
    {value: '3000000', text: '€ 3.000.000'},
    {value: '3500000', text: '€ 3.500.000'},
    {value: '4000000', text: '€ 4.000.000'},
    {value: '4500000', text: '€ 4.500.000'},
    {value: '5000000', text: '€ 5.000.000'}
];
